import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { EProcessStatus } from 'core/dto';
import { designerPaths } from './designer.paths';
import { LoginExpiredDialogComponent } from './global-services/login-expired-dialog/login-expired-dialog.component';
import { AuthComponent } from './modules/auth/auth.component';
import { AuthGuard } from './modules/auth/auth.guard';
import { AdminGuard } from './modules/auth/guards/admin.guard';
import { CreatorGuard } from './modules/auth/guards/creator.guard';
import { NotMobileGuard } from './modules/auth/guards/not-mobile.guard';
import { UserGuard } from './modules/auth/guards/user.guard';
import { OidcLogoutComponent } from './modules/auth/oidc-logout/oidc-logout.component';
import { OidcCallbackMockComponent } from './modules/auth/oidc/oidc-callback.mock.component';
import { ReverseAuthGuard } from './modules/auth/reverse-auth.guard';
import { ProcessOverviewComponent } from './modules/process-overview/process-overview.component';
import { ProcessOverviewDetailComponent } from './modules/process-overview/process-overview.detail/process-overview.detail.component';
import { UnauthorizedComponent } from './modules/shared/unauthorized/unauthorized.component';
import { SignProcessWizardComponent } from './modules/sign-process-wizard/sign-process-wizard.component';
import { TeamManagementDetailComponent } from './modules/team-management/team-management-detail/team-management-detail.component';
import { TeamManagementComponent } from './modules/team-management/team-management.component';
import { UserDetailComponent } from './modules/user-management/user-detail/user-detail.component';
import { UserManagementComponent } from './modules/user-management/user-management.component';
import { UserSetPasswordComponent } from './modules/user-management/user-set-password/user-set-password.component';



const routes: Routes = [
  {
    path: designerPaths.auth,
    component: AuthComponent,
    canActivate: [ReverseAuthGuard]
  },
  {
    path: designerPaths.oidcCallback,
    component: OidcCallbackMockComponent
  },
  {
    path: designerPaths.process,
    component: SignProcessWizardComponent,
    canActivate: [AuthGuard, CreatorGuard, NotMobileGuard]
  },
  {
    path: designerPaths.process + '/:processId',
    component: SignProcessWizardComponent,
    canActivate: [AuthGuard, CreatorGuard, NotMobileGuard]
  },
  {
    path: designerPaths.processOverview,
    component: ProcessOverviewComponent,
    canActivate: [AuthGuard]
  },
  {
    path: designerPaths.processOverview + '/:status',
    component: ProcessOverviewComponent,
    canActivate: [AuthGuard]

  },
  {
    path: designerPaths.processOverviewDetail + '/:processId',
    component: ProcessOverviewDetailComponent,
    canActivate: [AuthGuard]

  },
  {
    path: designerPaths.userManagement,
    component: UserManagementComponent,
    canActivate: [AuthGuard, AdminGuard]

  },
  {
    path: designerPaths.teamManagement,
    component: TeamManagementComponent,
    canActivate: [AuthGuard, AdminGuard]
  },
  {
    path: designerPaths.teamManagement + '/new',
    component: TeamManagementDetailComponent,
    canActivate: [AuthGuard, AdminGuard]
  },
  {
    path: designerPaths.teamManagement + '/:teamId',
    component: TeamManagementDetailComponent,
    canActivate: [AuthGuard, AdminGuard]
  },
  {
    path: designerPaths.userManagement + '/:id',
    component: UserDetailComponent,
    canActivate: [AuthGuard, UserGuard]

  },
  {
    path: designerPaths.setPassword + '/:userId',
    component: UserSetPasswordComponent,
    canActivate: [ReverseAuthGuard]
  },
  {
    path: designerPaths.oidcLogout,
    component: OidcLogoutComponent,
  },
  {
    path: designerPaths.sessionExpired,
    component: LoginExpiredDialogComponent,
  },
  {
    path: designerPaths.unauthorized,
    canActivate: [AuthGuard],
    component: UnauthorizedComponent,
  },
  {
    path: '',
    redirectTo: [designerPaths.processOverview, EProcessStatus.WaitingForMe].join('/'),
    pathMatch: 'full'
  },
  {
    path: '*',
    redirectTo: [designerPaths.processOverview, EProcessStatus.WaitingForMe].join('/'),
  },
  {
    path: '**',
    redirectTo: [designerPaths.processOverview, EProcessStatus.WaitingForMe].join('/'),
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
